import { defineComponent as _defineComponent } from 'vue'

  const __default__ = {
    name: 'LayoutFooter'
  }

import { computed, useStore, watch, useRoute } from '@nuxtjs/composition-api'
  import Richtext from '@/components/pure/Richtext/Richtext.vue'
  import IconArrow from '@/components/pure/IconArrow/IconArrow.vue'

  
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

  const store = useStore()
  const route = useRoute()
  const pid = computed(() => store.getters['projects/getActualProject'])
  const sid = computed(() => store.getters['projects/getActualSystem'])
  const flatNav = computed(() => store.getters['navigation/getFlatnav'])
  const polling = computed(() => store.getters['navigation/getPolling'])
  const whitelabelConfig = computed(() => store.getters['whitelabel/getConfig'])

  const retentlyTag = computed(() => {
    const allowedPartners = ['standalone', 'platform']
    const retentlyMatrix = {
      standalone: 'inapp-360monitoring,brand-360',
      platform: 'inapp-platform360,brand-360'

    }
    const partnerType = whitelabelConfig.value.partnerType

    if (allowedPartners.includes(partnerType)) {
      return retentlyMatrix[partnerType]
    }
  })

  watch(route, () => {
    changeNavPath()
  })
  watch(polling, () => {
    if (!polling.value) {
      changeNavPath()
    }
  })
  const changeNavPath = () => {
    if (route.value.path === '/') return
    const setNavPath = () => {
      const name = route.value.name?.replace(/___../g, '')
      if (name) {
        if (!flatNav.value[name]) return
        const { mainId, groupId, entryId } = flatNav.value[name]
        store.dispatch('navigation/setNavPath', {
          main: mainId || '',
          sub: entryId,
          group: groupId
        })
      }
    }

    if (Object.keys(flatNav.value).length) {
      setNavPath()
    } else {
      setTimeout(() => {
        setNavPath()
      }, 600)
    }
  }


return { __sfc: true,store, route, pid, sid, flatNav, polling, whitelabelConfig, retentlyTag, changeNavPath, Richtext, IconArrow }
}

})